// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reset and base styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: linear-gradient(135deg, #f7f9fc 0%, #eef1f7 100%);
  color: #1e293b;
  overflow: hidden;
}

/* ============ MINIMAL THEME ============ */

/* Credential inputs — soft focus ring + lift */
.cred-input {
  transition: border-color 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}
.cred-input:hover:not(:disabled) {
  border-color: #c7d2fe;
}
.cred-input:focus:not(:disabled) {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);
  background: #ffffff;
}

/* Cards lift subtly on hover */
.soft-card {
  transition: box-shadow 0.25s ease, transform 0.25s ease;
}
.soft-card:hover {
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
}

/* Clear-chat button hover */
.clear-btn {
  transition: all 0.18s ease;
}
.clear-btn:hover {
  background: #f1f5f9 !important;
  color: #334155 !important;
  border-color: #cbd5e1 !important;
}

/* Chat bubbles animate in */
@keyframes bubbleIn {
  from { opacity: 0; transform: translateY(8px) scale(0.98); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
}
.chat-bubble {
  animation: bubbleIn 0.28s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Soft pulse for the empty-state hint */
@keyframes softPulse {
  0%, 100% { opacity: 0.65; }
  50%      { opacity: 1; }
}
.empty-pulse {
  animation: softPulse 2.4s ease-in-out infinite;
}

/* Main App container */
.App {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
}

/* Header styling */
.app-header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(226, 232, 240, 0.8);
  padding: 24px 40px;
  text-align: center;
}

.app-header h1 {
  font-size: 32px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 8px;
  letter-spacing: -0.02em;
}

.app-header p {
  font-size: 16px;
  color: #64748b;
  font-weight: 400;
  letter-spacing: 0.01em;
}

/* Audio player (hidden but functional) */
.audio-player {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
  top: -9999px;
}

/* Responsive design */
@media (max-width: 768px) {
  .app-header {
    padding: 20px 24px;
  }
  
  .app-header h1 {
    font-size: 28px;
  }
  
  .app-header p {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .app-header {
    padding: 16px 20px;
  }
  
  .app-header h1 {
    font-size: 24px;
  }
  
  .app-header p {
    font-size: 13px;
  }
}

/* Loading states and transitions */
button {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Focus styles for accessibility */
button:focus-visible {
  outline: 2px solid #4a90e2;
  outline-offset: 2px;
}

/* Custom scrollbar (if needed) */
::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  background: #f8fafc;
}

::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.App {
  animation: fadeIn 0.5s ease-out;
}

/* Status indicators */
.status-connected {
  color: #10b981;
}

.status-listening {
  color: #4a90e2;
}

.status-speaking {
  color: #f59e0b;
}

.status-disconnected {
  color: #6b7280;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,iHAAiH;EACjH,mCAAmC;EACnC,kCAAkC;EAClC,6DAA6D;EAC7D,cAAc;EACd,gBAAgB;AAClB;;AAEA,4CAA4C;;AAE5C,+CAA+C;AAC/C;EACE,iFAAiF;AACnF;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,uDAAuD;AACzD;AACA;EACE,6CAA6C;AAC/C;;AAEA,4BAA4B;AAC5B;EACE,0BAA0B;AAC5B;AACA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,4BAA4B;AAC5B;EACE,OAAO,UAAU,EAAE,sCAAsC,EAAE;EAC3D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;AACA;EACE,sDAAsD;AACxD;;AAEA,wCAAwC;AACxC;EACE,WAAW,aAAa,EAAE;EAC1B,WAAW,UAAU,EAAE;AACzB;AACA;EACE,8CAA8C;AAChD;;AAEA,uBAAuB;AACvB;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,qCAAqC;EACrC,2BAA2B;EAC3B,iDAAiD;EACjD,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,oBAAoB;EACpB,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,mCAAmC;AACnC;EACE,iDAAiD;AACnD;;AAEA,mCAAmC;AACnC;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA,sBAAsB;AACtB;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* Reset and base styles */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: linear-gradient(135deg, #f7f9fc 0%, #eef1f7 100%);\n  color: #1e293b;\n  overflow: hidden;\n}\n\n/* ============ MINIMAL THEME ============ */\n\n/* Credential inputs — soft focus ring + lift */\n.cred-input {\n  transition: border-color 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;\n}\n.cred-input:hover:not(:disabled) {\n  border-color: #c7d2fe;\n}\n.cred-input:focus:not(:disabled) {\n  border-color: #6366f1;\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);\n  background: #ffffff;\n}\n\n/* Cards lift subtly on hover */\n.soft-card {\n  transition: box-shadow 0.25s ease, transform 0.25s ease;\n}\n.soft-card:hover {\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);\n}\n\n/* Clear-chat button hover */\n.clear-btn {\n  transition: all 0.18s ease;\n}\n.clear-btn:hover {\n  background: #f1f5f9 !important;\n  color: #334155 !important;\n  border-color: #cbd5e1 !important;\n}\n\n/* Chat bubbles animate in */\n@keyframes bubbleIn {\n  from { opacity: 0; transform: translateY(8px) scale(0.98); }\n  to   { opacity: 1; transform: translateY(0) scale(1); }\n}\n.chat-bubble {\n  animation: bubbleIn 0.28s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Soft pulse for the empty-state hint */\n@keyframes softPulse {\n  0%, 100% { opacity: 0.65; }\n  50%      { opacity: 1; }\n}\n.empty-pulse {\n  animation: softPulse 2.4s ease-in-out infinite;\n}\n\n/* Main App container */\n.App {\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n/* Header styling */\n.app-header {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 10;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  border-bottom: 1px solid rgba(226, 232, 240, 0.8);\n  padding: 24px 40px;\n  text-align: center;\n}\n\n.app-header h1 {\n  font-size: 32px;\n  font-weight: 700;\n  color: #1e293b;\n  margin-bottom: 8px;\n  letter-spacing: -0.02em;\n}\n\n.app-header p {\n  font-size: 16px;\n  color: #64748b;\n  font-weight: 400;\n  letter-spacing: 0.01em;\n}\n\n/* Audio player (hidden but functional) */\n.audio-player {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n  pointer-events: none;\n  top: -9999px;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .app-header {\n    padding: 20px 24px;\n  }\n  \n  .app-header h1 {\n    font-size: 28px;\n  }\n  \n  .app-header p {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 480px) {\n  .app-header {\n    padding: 16px 20px;\n  }\n  \n  .app-header h1 {\n    font-size: 24px;\n  }\n  \n  .app-header p {\n    font-size: 13px;\n  }\n}\n\n/* Loading states and transitions */\nbutton {\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Focus styles for accessibility */\nbutton:focus-visible {\n  outline: 2px solid #4a90e2;\n  outline-offset: 2px;\n}\n\n/* Custom scrollbar (if needed) */\n::-webkit-scrollbar {\n  width: 6px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f8fafc;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 3px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.App {\n  animation: fadeIn 0.5s ease-out;\n}\n\n/* Status indicators */\n.status-connected {\n  color: #10b981;\n}\n\n.status-listening {\n  color: #4a90e2;\n}\n\n.status-speaking {\n  color: #f59e0b;\n}\n\n.status-disconnected {\n  color: #6b7280;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
